import type { EditorCommandHost } from "@/editor/commands/editorCommandHost";
import { documentStore } from "@/editor/store";
import type { TopBarActionDeps, TopBarActions } from "./types";

export function createTopBarActions(host: EditorCommandHost, deps: TopBarActionDeps): TopBarActions {
  const historyState = () => host.history.getState(documentStore.getDocument().revision);

  return {
    canUndo: () => historyState().undoDepth > 0,
    canRedo: () => historyState().redoDepth > 0,
    undo: () => host.undo(),
    redo: () => host.redo(),
    changeTool: deps.changeTool,
    changeShapeKind: deps.changeShapeKind,
    applyBooleanOperation: deps.applyBooleanOperation,
    flattenSelectedNodes: deps.flattenSelectedNodes,
    requestNewDocument: deps.requestNewDocument,
    requestCurvaImport: deps.requestCurvaImport,
    requestComponentImport: deps.requestComponentImport,
    requestScriptImport: deps.requestScriptImport,
    requestScriptImportAndReplace: deps.requestScriptImportAndReplace,
    requestAddEditorScripts: deps.requestAddEditorScripts,
    requestReplaceEditorScripts: deps.requestReplaceEditorScripts,
    clearEditorScripts: deps.clearEditorScripts,
    openEditorScriptsDocument: deps.openEditorScriptsDocument,
    downloadEditorScriptsDocument: deps.downloadEditorScriptsDocument,
    exportCurvaFile: deps.exportCurvaFile,
    exportCurvaFileAs: deps.exportCurvaFileAs,
    exportSelectedFramesPdf: deps.exportSelectedFramesPdf,
    renameDocument: deps.renameDocument,
    toggleAnimationMode: deps.toggleAnimationMode,
    startSelectionColorSample: deps.startSelectionColorSample,
    enterSubdivide: deps.enterSubdivide,
    setSubdivideSegments: deps.setSubdivideSegments,
    commitSubdivide: deps.commitSubdivide,
    splitToRegions: deps.splitToRegions,
  };
}
